type GroupingFields = {
  grouping?: string | number | null;
  groupingFamily?: string | number | null;
};

const readGrouping = (
  source: unknown,
  preferFamily = false,
): string | number | null => {
  if (!source || typeof source !== "object") return null;
  const fields = source as GroupingFields;
  if (preferFamily) {
    return fields.groupingFamily ?? fields.grouping ?? null;
  }
  return fields.grouping ?? fields.groupingFamily ?? null;
};

export function getPatientGroupingDisplay(
  data?: {
    encounter?: unknown;
    pmaster?: unknown;
    patient?: unknown;
  } | null,
): string {
  if (!data) return "";

  const value =
    readGrouping(data.encounter) ??
    readGrouping(data.pmaster, true) ??
    readGrouping(data.patient, true) ??
    null;

  if (value === null || value === undefined || value === "") return "";
  return String(value);
}
